import Vue from 'vue'

export const languageUtil = {
    
    getLanguages() {
        
        let selector = [];

        Vue.prototype.$Params.idiomas.split(',').forEach(code => {
            const lng = code.trim();
            switch(lng) {
                case 'es': selector.push({id: lng, desc: 'Español'}); break;
                case 'ca': selector.push({id: lng, desc: 'Català'}); break;
                case 'en': selector.push({id: lng, desc: 'English'}); break;
                case 'de': selector.push({id: lng, desc: 'Deutsch'}); break;
            }
        });

        return selector;
    }
};
